import React, { useState } from 'react';
import { Button, Icon, Input, Radio, Upload } from '@alifd/next';
import LzTag from '@/components/common/LzTag';
import LzMsg from '@/components/common/LzMsg';
import styles from './index.module.scss';
import { Servlets } from '@/service/index';
import Utils from '@/common/utils';
import { store } from '@ice/stark-data';

/**
 * 专享客服用户营销黑名单导入
 * @param exportBlackInfo-用户填入的黑名单信息，导入成功失败的数量，失败的pins
 * @param confirm-确认导入事件
 * @param cancel-退出按钮事件
 */
const ExportBlack = ({
  cancel = () => {
  },
}) => {
  const [blackList, setBlackList] = useState(''); // 用户填入的列表
  const [errorExportList, setErrorExportList] = useState(''); // 导入失败的列表
  const [numInfo, setNumInfo] = useState({ // 导入成功失败的数量
    successNum: 0,
    errorNum: 0,
  });
  const [exprotMethod, setExportMethod] = useState(1); // 录入方式1：手工录入   2：文档导入
  const [iconType, setIconType] = useState(1); // 导入文件的图标
  // 获得 Authorization 上传没有走service方法
  const Authorization = sessionStorage.getItem('LZ_SSO_TOKEN');
  // 获得 prod
  const prod = "dy_cjyx";
  // 文件名
  const [fileName, setFileName] = useState();
  /**
   * 确认导入黑名单
   */
  const exportList = () => {
    const filterArr = blackList.replace(/[\r\n]/g, ',').split(',').filter((item) => {
      return item.length !== 0;
    });
    if (filterArr.length > 2000) {
      LzMsg.warning('最多输入2000条明文pin！');
    } else if (blackList.length === 0) {
      LzMsg.warning('请输入用户pin');
    } else {
      const tempParams = {
        blackPins: filterArr,
        // moduleType: 2 // 2-营销黑名单，1-邀请黑名单
      };
      Servlets('enterDyBlackPin', tempParams).then((res) => {
        setNumInfo({
          ...numInfo,
          successNum: res.data.successList.length + +res.data.existList.length,
          errorNum: res.data.failedList.length,
        });
        if (res.data.successList.length > 0) {
          LzMsg.success('导入成功');
        }
        // if (res.data.failedNums === 0) {
        //   LzMsg.success('导入成功');
        //   cancel();
        // }
        else {
          setErrorExportList(res.data.failedList.join(','));
        }
      });
    }
  };

  /**
   * 复制失败人的pin到剪切板
   */
  const copyPins = async () => {
    if (errorExportList) {
      await Utils.copyText(errorExportList);
      LzMsg.success('链接已经复制到剪切板');
    } else {
      LzMsg.warning('暂无导入失败用户');
    }
  };

  return (
    <div className={`${styles['export-black-list']}`}>
      <div className={`${styles['display-flex']}`} style={{ justifyContent: 'space-between' }}>
        <div>
          <p>录入方式：</p>
          <Radio.Group
            itemDirection={'hoz'}
            value={exprotMethod}
            onChange={(value) => {
              setExportMethod(Number(value));
            }}
          >
            <Radio value={1} style={{ background: '#FFFFFF' }}>手工录入</Radio>
            <Radio value={2} style={{ background: '#FFFFFF', marginLeft: '50px' }}>文档导入</Radio>
          </Radio.Group>
        </div>


      </div>
      {
        exprotMethod === 1 ? <Input.TextArea
          name="exportList"
          placeholder="请录入用户的手机号，一行一条"
          aria-label="auto height"
          autoHeight={{ minRows: 10, maxRows: 15 }}
          value={blackList}
          onChange={setBlackList}
          style={{
            width: `${100 }%`,
            marginTop: '10px',
            height: '180px',
            marginBottom: '8px',
          }}
        />
          : <div style={{ width: '100%' }}>
            {/* 上传文件 */}
            <Upload.Dragger
              style={{ marginTop: '10px', width: '100%', height: '180px', marginBottom: '8px' }}
              name="uploadedfile"
              listType="text"
              limit={1}
              onProgress={
                // 加载中
                () => {
                  setIconType(4);
                }
              }
              beforeUpload={(file) => {
                setFileName(file.name);
                // if (file.size > 20971520) {
                //   LzMsg.error('文件过大上传失');
                // }
              }}
              // 移除文件
              onRemove={(file) => {
                true;
                setIconType(1);
              }}
              method="post"
              // 添加请求头
              headers={{ prod, Authorization }}
              action="/api/blackpins/blackpin"
              withCredentials={false}
              // 文档上说明跨域用
              // headers={{ 'X-Requested-With': null }}
              onError={(value) => {
                const errorMessage = value.originFileObj.size;
                setIconType(3);
                LzMsg.error('上传失败');
              }}
              onSuccess={(res) => {
                console.log(res, 'res');
                setIconType(2);
                setNumInfo({
                  ...numInfo,
                  successNum: res.response.data.successList.length + res.response.data.existList.length,
                  errorNum: res.response.data.failedList.length,
                });
                if (res.response.data.successList.length > 0) {
                  LzMsg.success('上传成功');
                } else {
                  setErrorExportList(res.response.data.failedList.join(','));
                }
              }}
            >

              <div
                className="next-upload-drag"
                style={{
                  border: '1px solid #D7DDE4',
                  width: '100%',
                  height: '180px',
                  paddingTop: '47px',
                  textAlign: 'center',
                }}
              >

                {
                  iconType === 1 ? (
                    <div>
                      <span
                        className={'iconfont icon-icon2_huaban1-02'}
                        style={{
                          color: '#A69DFF',
                          fontSize: '50px',
                          fontWeight: 500,
                          fontFamily: 'PingFang SC',
                        }}
                      />
                      <div
                        className="next-upload-drag-text"
                        style={{ marginTop: '12px', color: '#5D4CFF' }}
                      >点击或将文件拖拽到这里上传
                      </div>
                      <span
                        className="next-upload-drag-hint"
                        style={{ marginTop: '10px', color: '#9CA7B6' }}
                      >支持扩展名：.txt(大小不超过20MB)
                      </span>
                    </div>
                  ) : (
                    iconType === 2 ? (
                      <span>
                        <div style={{ display: 'inline-flex', textAlign: 'center' }}>
                          <span className={'iconfont icon-icon4-24'} style={{ color: '#00BB66', fontSize: '32px' }} />
                          <span style={{ lineHeight: '18px', marginLeft: '11px' }}>上传成功，<span
                            className={'iconfont icon-icon5-17'}
                            style={{ color: '#657180' }}
                          /> 文件：{fileName}
                          </span>
                        </div>
                        <div>
                          {/* <Button type="normal" style={{ width: '88px', height: '30px', marginTop: '33px' }}>删除</Button> */}
                        </div>
                      </span>
                    ) : (
                      iconType === 3 ? (
                        <span>
                          <div style={{ display: 'inline-flex', textAlign: 'center' }}>
                            <span
                              className={'iconfont icon-icon4-30'}
                              style={{ color: '#FF3333', fontSize: '32px' }}
                            />
                            <span style={{ lineHeight: '40px', marginLeft: '11px' }}>上传失败，上传文件与模板不符</span>
                          </div>
                          <div>
                            {/* <Button type="primary" style={{ width: '88px', height: '30px', marginTop: '33px' }}>重新上传</Button> */}
                          </div>
                        </span>
                      ) : (
                        <span>
                          <div style={{ display: 'inline-flex', textAlign: 'center' }}>
                            <Icon
                              type="loading"
                              style={{ color: '#3399FF', fontSize: '32px', width: '32px', height: '32px' }}
                            />
                          </div>
                          <div style={{
                            marginTop: '5px',
                            fontSize: '12px',
                            fontWeight: 500,
                            fontFamily: 'PingFang SC',
                          }}
                          >
                            上传中...
                          </div>
                        </span>
                      )
                    )
                  )
                }

              </div>
            </Upload.Dragger>
          </div>
      }

      <p>
        {exprotMethod === 1 ?
          <LzTag.Disable>请录入用户的手机号，一行一条，单次最多添加<LzTag.Error>&nbsp;2000&nbsp;</LzTag.Error>条</LzTag.Disable>
          :
          <LzTag.Disable>注：请注意上传中请不要关闭此页面</LzTag.Disable>
        }
      </p>

      <Button
        type="secondary"
        className={'submit-btn'}
        style={{ width: '88px', marginTop: '10px' }}
        onClick={exportList}
      >导入
      </Button>

      <div style={{ marginTop: '20px' }}>
        已成功导入 <LzTag.Success>{numInfo.successNum}</LzTag.Success> 个手机号，失败 <LzTag.Error>{numInfo.errorNum}</LzTag.Error> 个
      </div>
      <div>
        {
          errorExportList.length > 0 &&
          <Input.TextArea
            disabled
            name="errorList"
            className={'market-black-error-input'}
            autoHeight
            value={errorExportList}
            style={{ width: `${100 }%`, marginTop: '10px', height: '120px', overflowY: 'auto' }}
          />
        }
        {
          errorExportList.length <= 0 &&
          <Input.TextArea disabled className={'market-black-error-none'} value="-暂无相关数据-" />
        }
      </div>
      {/* <div className={styles.globalLink} style={{ lineHeight: '30px', color: '#5d4cff', cursor: 'pointer' }} onClick={copyPins}>复制</div> */}
      <Button text style={{ marginTop: '8px' }} onClick={copyPins}>复制</Button>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px', marginTop: '30px' }}>
        <Button
          type="normal"
          className={`cancel-btn ${styles.mr10}`}
          style={{ width: '88px' }}
          onClick={cancel}
        >关闭
        </Button>

      </div>
    </div>
  );
};
export default ExportBlack;
